import {
  CopilotDiffChatBlobActionsMenuItems,
  type CopilotDiffChatBlobActionsMenuItemsProps,
} from '@github-ui/copilot-code-chat/CopilotDiffChatBlobActionsMenuItems'
import type {RepositoryNWO} from '@github-ui/current-repository'
import {blobPath, deleteBlobPath, editBlobPath} from '@github-ui/paths'
import {EyeIcon, KebabHorizontalIcon, PencilIcon, TrashIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

interface BlobActionsMenuProps {
  oid: string
  path: string
  repo: RepositoryNWO
  branchName?: string
  isViewable?: boolean
  isDeleteable?: boolean
  isEditable?: boolean
  copilotDiffChatProps?: CopilotDiffChatBlobActionsMenuItemsProps
  returnToPullRequestPath?: string
}

export function BlobActionsMenu({
  oid,
  path,
  repo,
  branchName,
  isViewable = true,
  isDeleteable = true,
  isEditable = true,
  copilotDiffChatProps,
  returnToPullRequestPath,
}: BlobActionsMenuProps) {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton icon={KebabHorizontalIcon} aria-label="More options" variant="invisible" size="small" />
      </ActionMenu.Anchor>

      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.LinkItem
            href={blobPath({
              repo: repo.name,
              owner: repo.ownerLogin,
              filePath: path,
              commitish: oid,
            })}
            inactiveText={isViewable ? undefined : 'Action unavailable'}
          >
            <ActionList.LeadingVisual>
              <EyeIcon />
            </ActionList.LeadingVisual>
            View file
          </ActionList.LinkItem>
          {branchName && (
            <>
              <ActionList.LinkItem
                href={editBlobPath({
                  repo: repo.name,
                  owner: repo.ownerLogin,
                  filePath: path,
                  commitish: branchName,
                  returnToPrPath: returnToPullRequestPath,
                })}
                inactiveText={isEditable ? undefined : 'Action unavailable'}
              >
                <ActionList.LeadingVisual>
                  <PencilIcon />
                </ActionList.LeadingVisual>
                Edit file
              </ActionList.LinkItem>
              <ActionList.LinkItem
                variant="danger"
                href={deleteBlobPath({
                  repo: repo.name,
                  owner: repo.ownerLogin,
                  filePath: path,
                  commitish: branchName,
                })}
                inactiveText={isDeleteable ? undefined : 'Action unavailable'}
              >
                <ActionList.LeadingVisual>
                  <TrashIcon />
                </ActionList.LeadingVisual>
                Delete file
              </ActionList.LinkItem>
            </>
          )}
          {copilotDiffChatProps && <CopilotDiffChatBlobActionsMenuItems {...copilotDiffChatProps} />}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ BlobActionsMenu.displayName ||= 'BlobActionsMenu' } catch {}